export default __webpack_public_path__ + "static/media/arrow_right.846912b9.svg";